<div class="main" [formGroup]="formGroup" [style.width.px]="dialogWidth$ | async"
    [style.left.px]="dialogLeftPosition$ | async">
    <div class="message">{{ dialogService.message$ | async }}</div>

    <div class="comment-section">
        <div class="comment-subsection">
            <div class="subsection-heading">Changes</div>
            <textarea data-testid="release-comment-input" spellcheck="true" class="comment" placeholder="enter changes"
                formControlName="changes"></textarea>
        </div>
    </div>
    <div class="actions">
        <div class="button right" data-testid="release-comment-continue-button" [ngClass]="{'disabled': this.formGroup.invalid}" (click)="submitResponse()">continue
        </div>
        <div (click)="cancel()" class="button">cancel</div>
    </div>
</div>
